import { motion } from "framer-motion";
import React from "react";

function Github2() {
  return (
    <>
      <motion.svg
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 1.1 }}
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#6C27B3"
        />
        <path
          d="M17.5647 6.23072C16.1309 6.41222 14.636 6.40589 13.1315 6.26264C11.0304 6.10102 7.95976 5.13132 6.82843 7.07072C5.01099 10.1755 5.90738 14.1505 6.3309 17.6681L12.6467 23.9825C18.7586 23.658 23.657 18.7603 23.9825 12.6487L17.5647 6.23072Z"
          fill="#501A96"
        />
        <path
          d="M13.8974 19V16.6073C13.9186 16.3125 13.8823 16.0162 13.7908 15.7379C13.6994 15.4597 13.555 15.206 13.3672 14.9937C15.1385 14.7773 17 14.0416 17 10.6659C16.9999 9.80268 16.6969 8.97258 16.1538 8.3474C16.411 7.5922 16.3928 6.75746 16.1031 6.01657C16.1031 6.01657 15.4374 5.80017 13.8974 6.93159C12.6045 6.54754 11.2416 6.54754 9.94872 6.93159C8.40872 5.80017 7.74308 6.01657 7.74308 6.01657C7.45334 6.75746 7.43516 7.5922 7.69231 8.3474C7.1452 8.97722 6.84194 9.81482 6.84615 10.6844C6.84615 14.0354 8.70769 14.7711 10.479 15.0122C10.2934 15.2224 10.1503 15.4731 10.0589 15.7479C9.96753 16.0227 9.92999 16.3156 9.94872 16.6073V19M9.94872 17.1452C7.12821 18.0726 7.12821 15.5996 6 15.2904L9.94872 17.1452Z"
          stroke="#F8ECF8"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </motion.svg>
    </>
  );
}

export { Github2 };
